import { FC } from 'react';

import isNil from 'lodash/isNil';

import { FULL_PRICE_FIELD_NAME, MONTHLY_PRICE_FIELD_NAME } from '../../constants';
import { FacetPrice, FilterRange } from '../../model';
import { FacetItem } from '../FacetItem/FacetItem';
import { FacetPriceFilter } from '../FacetPriceFilter/FacetPriceFilter';
import { FacetContainer } from './Facets.styles';

type Props = {
    facet: FacetPrice;
    priceTypeFieldName?: string;
    filter?: FilterRange;
    onChange: (fieldName: string, filter?: FilterRange) => void;
};

export const PriceFacet: FC<Props> = ({ facet, priceTypeFieldName, filter, onChange }) => {
    const hasMonthlyPrice = !isNil(facet?.monthlyPrice?.min) && !isNil(facet?.monthlyPrice?.max);

    const handleFilterChange = (type: 'MONTHLY' | 'FULL', from: number, to: number) => {
        const fieldName = type === 'MONTHLY' ? MONTHLY_PRICE_FIELD_NAME : FULL_PRICE_FIELD_NAME;

        const minValue = type === 'MONTHLY' ? facet.monthlyPrice.min : facet.fullPrice.min;
        const maxValue = type === 'MONTHLY' ? facet.monthlyPrice.max : facet.fullPrice.max;
        const filterValue = type === 'FULL' || from > minValue || to < maxValue ? { gte: from, lte: to } : undefined;

        onChange(fieldName, filterValue);
    };

    const selectedPriceType =
        hasMonthlyPrice && (!priceTypeFieldName || priceTypeFieldName === MONTHLY_PRICE_FIELD_NAME)
            ? 'MONTHLY'
            : 'FULL';
    const fromValue = filter?.gte;
    const toValue = filter?.lte;

    return (
        <FacetItem id={facet.key} label={facet.label} facetType="price">
            <FacetContainer>
                <FacetPriceFilter
                    minMonthlyPrice={facet?.monthlyPrice?.min}
                    maxMonthlyPrice={facet?.monthlyPrice?.max}
                    minFullPrice={facet?.fullPrice?.min}
                    maxFullPrice={facet?.fullPrice?.max}
                    defaultSelectedType={selectedPriceType}
                    defaultFromValue={fromValue}
                    defaultToValue={toValue}
                    onChange={handleFilterChange}
                />
            </FacetContainer>
        </FacetItem>
    );
};
